import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Injectable, Injector } from '@angular/core';
import 'rxjs/add/operator/do';

import { AuthService } from './auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private authService: AuthService;

    constructor(private injector: Injector) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.authService = this.injector.get(AuthService); // get it here within intercept

        if (req.url.indexOf('login') === -1) {

            const copiedReq = req.clone({
                setHeaders: {
                    Authorization: this.authService.getAuthorizationHeader()
                }
            });


            return next.handle(copiedReq).do((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    // do stuff with response
                }
            }, (err: any) => {
                if (err instanceof HttpErrorResponse) {
                    if (this.isUnauthorized(err.status)) {
                        this.authService.logout();
                    }
                }

            });

        }
        return next.handle(req);

    }

    private isUnauthorized(status: number): boolean {
        return status === 401;
      }
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/auth/auth-interceptor.service.ts